import BaseModel from '../core/BaseModel'
export default class StatusDocumentModel extends BaseModel {

    constructor() {
        super({ 
                name: "status_document",
                tableName: 'status_document', 
                label: "Trạng thái văn bản", 
                display_key: 'name', 
                default_order: { key: 'ordinal', direction: 'asc' } }, 
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                // display: { list: true, add: false, edit: false }
            },
            id: { 
                name: 'id', 
                type: "Int", 
                label: 'ID', 
                primaryKey: true, 
                // edit: {
                //     add: false, 
                //     edit: false 
                // }, 
                display: false
            },
            name: {
                name: 'name', 
                type: "String",
                label: 'Tên',
                width :15, 
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            code: {
                name: 'code', 
                type: "String",
                label: 'Mã',
                width :15, 
                // filter: { type: 'input', match: 'contains'},
                // display: false
            },
            ordinal: {
                name: 'ordinal', 
                type: "Int",
                label: 'Thứ tự',
                width :15, 
                filter: { type: 'input', match: 'contains'},
                display: false
            }
        },)
    }

}